import React, { useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import InternationalPhoneInput from '../../components/Common/InternationalPhoneInput/InternationalPhoneInput';
import './ContactUsPage.css';

export default function ContactUsPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    countryCode: '+91',
    phone: '',
    email: '',
    city: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.firstName || !formData.phone || !formData.city) {
      alert('Please fill in all required fields (*)');
      return;
    }
    setSubmitted(true);
  };

  const [zoomScale, setZoomScale] = useState(1);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleZoomIn = () => {
    setZoomScale((prev) => Math.min(prev + 0.25, 2.5));
  };

  const handleZoomOut = () => {
    setZoomScale((prev) => Math.max(prev - 0.25, 0.75));
  };

  const toggleFullscreen = () => {
    setIsFullscreen((prev) => !prev);
  };

  const staticMapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.878950856093!2d77.6734291!3d12.8527299!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae6c94a69195e9%3A0xeb9627b100687bb3!2sHaatza%20India%20Private%20Limited!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin";

  return (
    <div className="contact-page-wrapper">
      <Navbar />

      <section className="contact-hero-section">
        <div className="contact-page-inner">
          <div className="contact-grid-2">

            {/* LEFT COLUMN: KEEP IN TOUCH FORM */}
            <div className="contact-form-card">
              <h1 className="contact-form-title">Keep in touch</h1>

              {submitted ? (
                <div className="contact-success-msg">
                  <div className="success-icon">✓</div>
                  <h3>Thank you for reaching out!</h3>
                  <p>Our seller support team will contact you shortly.</p>
                  <button onClick={() => setSubmitted(false)} className="reset-btn">Send Another Message</button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form-element">

                  {/* Name */}
                  <div className="contact-field">
                    <label htmlFor="cu-firstName">Name *</label>
                    <input
                      type="text"
                      id="cu-firstName"
                      name="firstName"
                      placeholder="First name"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Phone */}
                  <div className="contact-field">
                    <label htmlFor="cu-phone">Phone *</label>
                    <InternationalPhoneInput
                      phone={formData.phone}
                      onChangePhone={(val) => setFormData(prev => ({ ...prev, phone: val }))}
                      countryCode={formData.countryCode}
                      onChangeCountryCode={(code) => setFormData(prev => ({ ...prev, countryCode: code }))}
                      required
                    />
                  </div>

                  {/* Email */}
                  <div className="contact-field">
                    <label htmlFor="cu-email">Email</label>
                    <input
                      type="email"
                      id="cu-email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  {/* City */}
                  <div className="contact-field">
                    <label htmlFor="cu-city">City *</label>
                    <input
                      type="text"
                      id="cu-city"
                      name="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Message */}
                  <div className="contact-field">
                    <label htmlFor="cu-message">Message</label>
                    <textarea
                      id="cu-message"
                      name="message"
                      rows="4"
                      placeholder="Message"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  {/* Submit Button — centered pill */}
                  <div className="contact-submit-btn-wrap">
                    <button type="submit" className="contact-submit-btn">
                      Submit
                    </button>
                  </div>
                </form>
              )}
            </div>

            {/* RIGHT COLUMN: SELLER SUPPORT INFO & MAP — transparent panel */}
            <div className="contact-info-panel">
              <div className="support-header">
                <span className="support-emoji-icon">🏢</span>
                <h2 className="support-title">Seller Support</h2>
              </div>

              <p className="support-body-text">
                If you're a seller on Haatza and need help with listings, payments, or shipping:
              </p>

              <div className="contact-detail-lines">
                <div className="contact-detail-line">
                  <span className="cu-label">Email: </span>
                  <a href="mailto:sales@haatza.com">sales@haatza.com</a>
                </div>
                <div className="contact-detail-line">
                  <span className="cu-label">Dedicated Helpline: </span>
                  <span className="cu-phone-text">+91-914 807 9015</span>
                </div>
              </div>

              {/* EMBEDDED GOOGLE MAP with custom interactive controls */}
              <div className={`contact-map-block ${isFullscreen ? 'cu-map-fullscreen' : ''}`}>
                <iframe
                  title="Haatza India Location Map"
                  className="contact-map-iframe"
                  src={staticMapUrl}
                  style={{
                    transform: `scale(${zoomScale})`,
                    transformOrigin: 'center center',
                    transition: 'transform 0.25s ease-out'
                  }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>

                {/* TOP-RIGHT CORNER FULLSCREEN BUTTON */}
                <div className="cu-map-controls-tr">
                  <button 
                    type="button" 
                    className="cu-map-control-btn cu-fullscreen-btn" 
                    onClick={toggleFullscreen}
                    title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
                    aria-label="Toggle Fullscreen"
                  >
                    {isFullscreen ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"/></svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>
                    )}
                  </button>
                </div>

                {/* BOTTOM-RIGHT CORNER ZOOM CONTROLS */}
                <div className="cu-map-controls-br">
                  <div className="cu-zoom-controls-group">
                    <button 
                      type="button" 
                      className="cu-map-control-btn cu-zoom-btn" 
                      onClick={handleZoomIn}
                      title="Zoom In"
                      aria-label="Zoom In"
                    >
                      +
                    </button>
                    <button 
                      type="button" 
                      className="cu-map-control-btn cu-zoom-btn" 
                      onClick={handleZoomOut}
                      title="Zoom Out"
                      aria-label="Zoom Out"
                    >
                      −
                    </button>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
